export default {"src":"/_next/static/media/distance-icon.5b378e5c.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};